<div class="w-full p-[40px] flex flex-wrap gap-x-[4%] lg:gap-x-[2%] gap-y-[40px] items-center ">
    <div class="w-[48%] lg:w-[23.5%] min-h-[125px] p-[20px] rounded-[12px] shadow-lg flex flex-wrap">
        <div class="text-primary text-title flex items-center">Numero prenotazioni:</div>
        <div class="text-primary text-title items-center flex mx-auto">{{dashboardData.noOfBookings}}</div>
    </div>
    <div class="w-[48%] lg:w-[23.5%] min-h-[125px] p-[20px] rounded-[12px] shadow-lg flex flex-wrap">
        <div class="text-primary text-title flex items-center">Numero compagnie:</div>
        <div class="text-primary text-title items-center flex mx-auto">{{dashboardData.noOfCompanies}}</div>
    </div>
    <div class="w-[48%] lg:w-[23.5%] min-h-[125px] p-[20px] rounded-[12px] shadow-lg flex flex-wrap">
        <div class="text-primary text-title flex items-center">Numero saloni:</div>
        <div class="text-primary text-title items-center flex mx-auto">{{dashboardData.noOfSalons}}</div>
    </div>
    <div class="w-[48%] lg:w-[23.5%] min-h-[125px] p-[20px] rounded-[12px] shadow-lg flex flex-wrap">
        <div class="text-primary text-title flex items-center">Numero utenti:</div>
        <div class="text-primary text-title items-center flex mx-auto">{{dashboardData.noOfUsers}}</div>
    </div>
</div>